<template>
  <NuxtLink :to="term" class="add-card">
    <div class="add-card__wrap">
      <div class="add-card__content">
        <img
          src="/img/lobby/games.webp"
          alt="gray heart"
          class="add-card__icon"
        />
        <UiText
          :text="$t('lobby.favourites.title')"
          class="add-card__title"
          color="typography-title01"
          font="components-card-title"
          align-center
        />
        <UiText
          :text="$t('lobby.favourites.desk')"
          class="add-card__desk"
          color="typography-body01,"
          font="body-text-small"
          align-center
        />
      </div>

      <UiBtn
        class="add-card__btn"
        color="gray"
        :text="$tc('lobby.favourites.add')"
        size-small-mobile
      />
    </div>
  </NuxtLink>
</template>

<script>
export default {
  name: 'AddCard',
  props: {
    term: { type: String },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
